export default "__VITE_ASSET__C_yikT4s__"